let longRange = [
  {
    path: '/longRange_index',
    name: '远程诊疗',
    component: () => import('@/pages/longRange/longRange_index')
  },
  {
    path: '/longRange_group_confirm',
    name: '远程会诊',
    component: () => import('@/pages/longRange/longRange_group_confirm')
  },
  {
    path: '/longRange_material',
    name: '用户资料',
    component: () => import('@/pages/longRange/longRange_material')
  },
  {
    path: '/longRange_out_confirm',
    name: '远程门诊',
    component: () => import('@/pages/longRange/longRange_out_confirm')
  },
  {
    path: '/longRange_order_pay',
    name: '确认支付',
    component: () => import('@/pages/longRange/longRange_order_pay')
  }
]

export default longRange
